/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import {
  ADD_CATEGRORY,
  ADD_VENDOR,
  CATEGORY_LIST,
  INVENTORY_ADD,
  INVENTORY_DELETE,
  INVENTORY_LIST,
  INVENTORY_STATUS_CHANGE,
  INVENTORY_UPDATE,
  VENDOR_LIST,
} from "../../../../repository/Inventory-repo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useReduxStore from "../../../../hooks/useReduxStore";

const useOpeningStock = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
   const [totalCount, setTotalCount] = useState(0);
  const [inventoryList, setInventoryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [categoryModal, setCategoryModal] = useState(false);
  const [vendorModal, setVendorModal] = useState(false);
  const [errorVendor, setErrorVendor] = useState({})
  const [errorCategory, setErrorCategory] = useState({})

const [filter, setFilter] = useState({
  search: "",
  isDeleted: false, // default to Active
});

  const [formError, setFormError] = useState({})
  const { id } = useParams(); // Get ID from URL params
  const location = useLocation(); // Get data from navigation state
   const isEditMode = Boolean(id);
  const handleOpenCategroyModal = () => {
    setCategoryModal(true);
  };

  const handleCloseCategroyModal = () => {
    setCategoryModal(false);
  };

  const handleOpenVendorModal = () => {
    setVendorModal(true);
  };

  const handleCloseVendorModal = () => {
    setVendorModal(false);
    setErrorVendor({});
  };

    const isValid = () => {
    const errorObj = {};
    const {category, units,vendor  } = formData;

  if (!category) errorObj["category"] = "Category is required";
  if (!units) errorObj["units"] = "Units are required";
  if (!vendor) errorObj["vendor"] = "Vendor is required";

    setFormError(errorObj);
    return Object.keys(errorObj).length === 0;
  };

const isValidVendor = () => {
  const errorObj = {};
  if (!formDataVendor.name?.trim()) {
    errorObj["name"] = "Vendor is required";
  }

  setErrorVendor(errorObj);
  return Object.keys(errorObj).length === 0;
};

const isValidCategory = () => {
  const errorObj = {};
  if (!formDataCategory.name?.trim()) {
    errorObj["name"] = "Name is required";
  }

  setErrorCategory(errorObj);
  return Object.keys(errorObj).length === 0;
};

  const unitsList = [
    { name: "PACKS", id: "PACKS" },
    { name: "PIECES", id: "PIECES" },
    { name: "ROLLS", id: "ROLLS" },
    { name: "BOX", id: "BOX" },
    { name: "BOTTLES", id: "BOTTLES" },
    { name: "BAGS", id: "BAGS" },
    { name: "BUNDLES", id: "BUNDLES" },
    { name: "CANS", id: "CANS" },
    { name: "CARTONS", id: "CARTONS" },
    { name: "DOZENS", id: "DOZENS" },
    { name: "BOXGRAMMES", id: "BOXGRAMMES" },
    { name: "KILOGRAMS", id: "KILOGRAMS" },
    { name: "LITRE", id: "LITRE" },
    { name: "METERS", id: "METERS" },
    { name: "MILLILITRE", id: "MILLILITRE" },
    { name: "NUMBERS", id: "NUMBERS" },
    { name: "PAIRS", id: "PAIRS" },
    { name: "SQUAREFEET", id: "SQUAREFEET" },
    { name: "SQUAREMETER", id: "SQUAREMETER" },
    { name: "TABLETS", id: "TABLETS" },
  ];

  const [formData, setFormData] = useState({
    productName: "",
    price: null,
    purchasePrice: null,
    quantity: null,
    units: "",
    minimumQuantityLevel: null,
    category: "",
    vendor: "",
  });

  const [formDataCategory, setFormDataCategory] = useState({
        name: "",
  })
  const [formDataVendor, setFormDataVendor] = useState({
        name: "",
        address: "",
        gstNumber: "",
  })


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setFormError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  
  const handleChangeCategory = (e) => {
    const { name, value, type, checked } = e.target;

    setFormDataCategory((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrorCategory((prev)=>({
        ...prev,
        [name]:''
    }))
  };

    const handleChangeVendor = (e) => {
    const { name, value, type, checked } = e.target;

    setFormDataVendor((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrorVendor((prev)=>({
      ...prev,
      [name]:'',
    }))
  };

      const handlePagination = (obj) => {
        setController(obj);
    };


    // Initial load - for list page
  useEffect(() => {
    if (!isEditMode) {
      inventoryListAPI();
    }
    categoryListAPI();
    vendorListAPI();
  }, []);


    // Trigger API call when pagination changes - for list page
    useEffect(() => {
    if (!isEditMode) {
      inventoryListAPI();
    }
  }, [controller.page, controller.rowsPerPage]);


  // Load data for edit mode
  useEffect(() => {
    if (isEditMode && location.state?.inventoryData) {
      const data = location.state.inventoryData;
      setFormData({
        productName: data.productName || "",
        price: data.price || null,
        purchasePrice: data.purchasePrice || null,
        quantity: data.quantity || null,
        units: data.units || "",
        minimumQuantityLevel: data.minimumQuantityLevel || null,
        category: data.category?._id || data.category || "",
        vendor: data.vendor?._id || data.vendor || "",
      });
    }
  }, [isEditMode, location.state]);



const handleSearchChange = (e) => {
  setFilter((prev) => ({
    ...prev,
    search: e.target.value,
  }));
};


const handleStatusChange = (value) => {
  setFilter((prev) => ({
    ...prev,
    isDeleted: value,
  }));
};

const handleApplyFilter = () => {
    // reset to first page
  setController((prev) => ({ ...prev, page: 1 }));

  // use latest filter and page=1
  inventoryListAPI({ ...filter, page: 1 });
};


const handleResetFilter = () => {
  const newFilter = { search: "", isDeleted: false, isActive: false };
  setFilter(newFilter);
      // reset to first page and reload
  setController((prev) => ({ ...prev, page: 1 }));
  inventoryListAPI(newFilter); 
};


  const inventoryListAPI = async (filterOverride = filter) => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        search: filterOverride.search?.trim() || null,
      };

      if (filterOverride.isDeleted === "true")  payload.isDeleted = true;
      else if (filterOverride.isDeleted === "false") {
         payload.isActive = true;
         payload.isDeleted = false;
      } 

      setSpinner(true);
      let response = await INVENTORY_LIST(payload);
      setInventoryList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      setInventoryList([]);
    }
    setSpinner(false);
  };
  

  const categoryListAPI = async () => {
    try {
      let payload = {
        page: 1,
        count: 1000,
        isActive: true,
        isDeleted: false,
      };

      setSpinner(true);
      let response = await CATEGORY_LIST(payload);
      setCategoryList(response?.data);
    } catch (error) {
      setCategoryList([]);
    }
    setSpinner(false);
  };

  const vendorListAPI = async () => {
    try {
      let payload = {
        page: 1,
        count: 1000,
        isActive: true,
        isDeleted: false,
      };

      setSpinner(true);
      let response = await VENDOR_LIST(payload);
      setVendorList(response?.data);
    } catch (error) {
      setVendorList([]);
    }
    setSpinner(false);
  };

  const inventoryAdd = async () => {
      if(!isValid()) return;
    try {
      let payload = {
        productName: formData.productName,
        price: formData.price,
        purchasePrice: formData.purchasePrice,
        quantity: formData.quantity,
        units: formData.units,
        minimumQuantityLevel: formData.minimumQuantityLevel,
        category: formData.category,
        vendor: formData.vendor,
      };

      setSpinner(true);
      let response = await INVENTORY_ADD(payload);
      if (response.code === 200) {
        toast.success(response.message || "Inventory created successfully");
        inventoryListAPI();
        setTimeout(()=>{
          navigate('/setting/opening-stock')
        }, 500)
       
        setFormData({});
      } else {
        toast.error(response.message || "Inventory create failed");
      }
    } catch (error) {
      setInventoryList([]);
    }
    setSpinner(false);
  };

  const inventoryUpdate = async () => {
    if(!isValid()) return;
    try {
      let payload = {
        productName: formData.productName,
        price: formData.price,
        purchasePrice: formData.purchasePrice,
        quantity: formData.quantity,
        units: formData.units,
        minimumQuantityLevel: formData.minimumQuantityLevel,
        category: formData.category,
        vendor: formData.vendor,
        _id:id
      };

      setSpinner(true);
      let response = await INVENTORY_UPDATE(payload);
      if (response.code === 200) {
        toast.success(response.message || "Inventory updated successfully");
        inventoryListAPI();
        setTimeout(()=>{
          navigate('/setting/opening-stock')
        }, [2000])
       
        setFormData({});
      } else {
        toast.error(response.message || "Inventory update failed");
      }
    } catch (error) {
      setInventoryList([]);
    }
    setSpinner(false);
  };

    const inventoryDelete = async (id, isDeleted) => {
  
    try {
      let payload = {
        _id:id,
        isDeleted:!isDeleted, 
      };

      setSpinner(true);
      let response = await INVENTORY_DELETE(payload);
      if (response.code === 200) {
        toast.success(response.message ||  (isDeleted ? "Inventory recovered successfully" : "Inventory deleted successfully"));
      const newPage =
      inventoryList.length === 1 && controller.page > 1
      ? controller.page - 1
      : controller.page;

       setController((prev) => ({ ...prev, page: newPage }));
       inventoryListAPI();
      
      } else {
        toast.error(response.message || "Inventory delete failed");
      }
    } catch (error) {
      setInventoryList([]);
    }
    setSpinner(false);
  };

  

  const addCategory = async () => {
      if(!isValidCategory()) return;
    try {
      let payload = {
        name:formDataCategory.name,
      };

      setSpinner(true);
      let response = await ADD_CATEGRORY(payload);
      if (response.code === 200) {
        toast.success(response.message || "Category added successfully");
        categoryListAPI();
        handleCloseCategroyModal()
        setFormDataCategory({});
        setErrorCategory({});
      } else {
        toast.error(response.message || "Category add failed");
      }
    } catch (error) {
      categoryListAPI([]);
    }
    setSpinner(false);
  };

  const addVendor = async () => {
    if(!isValidVendor()) return;
    try {
      let payload = {
        name: formDataVendor.name,
        address: formDataVendor.gstNumber,
        gstNumber: formDataVendor.gstNumber,
      };

      setSpinner(true);
      let response = await ADD_VENDOR(payload);
      if (response.code === 200) {
        toast.success(response.message || "Vendor added successfully");
        vendorListAPI();
        handleCloseVendorModal()
        setFormDataVendor({});
        setErrorVendor({})
      } else {
        toast.error(response.message || "Category add failed");
      }
    } catch (error) {
      categoryListAPI([]);
    }
    setSpinner(false);
  };


  const ToggleStatusChange = async (id, isActive) => {
    try {
      const payload = {
        _id: id,
        isActive: isActive,
      };
  
      setSpinner(true);
      const response = await INVENTORY_STATUS_CHANGE(payload);
  
      if (response?.code === 200) {
        toast.success(response?.message || "Status updated successfully");
        await inventoryListAPI(); // refresh updated list
      } else {
        toast.error(response?.message || "Failed to update status");
      }
    } catch (error) {
      toast.error("Something went wrong while updating vendor status");
    } finally {
      setSpinner(false);
    }
  };
  
  const handleToggleChange = (id, currentStatus) => {
    const newStatus = !currentStatus;
    ToggleStatusChange(id, newStatus);
  };
  

  return {
    data: {
      spinner,
      inventoryList,
      unitsList,
      categoryList,
      vendorList,
      formData,
      categoryModal,
      vendorModal,
      formDataCategory,
      formDataVendor,
      formError,
      isEditMode,
      controller,
      totalCount,
      filter,
      errorVendor,
      errorCategory
    },
    methods: {
      handleChange,
      inventoryAdd,
      handleOpenCategroyModal,
      handleCloseCategroyModal,
      handleOpenVendorModal,
      handleCloseVendorModal,
      addCategory,
      addVendor,
      handleChangeCategory,
      handleChangeVendor,
      inventoryUpdate,
      handlePagination,
      inventoryDelete,
      handleToggleChange,
       handleSearchChange,
    handleStatusChange,
    handleApplyFilter,
    handleResetFilter,
    setFormData,
    setFormError
    },
  };
};

export default useOpeningStock;
